export default {
  name: 'colors',
  data () {
    return {
      "colorVars": [
        {
          "name": "white",
          "var": "$white",
          "invert": "$white-invert"
        },
        {
          "name": "black",
          "var": "$black",
          "invert": "$white"
        },
        {
          "name": "light",
          "var": "$light",
          "invert": "$light-invert"
        },
        {
          "name": "dark",
          "var": "$dark",
          "invert": "$dark-invert"
        },
        {
          "name": "primary",
          "var": "$primary",
          "invert": "$primary-invert"
        },
        {
          "name": "info",
          "var": "$info",
          "invert": "$info-invert"
        },
        {
          "name": "success",
          "var": "$success",
          "invert": "$success-invert"
        },
        {
          "name": "warning",
          "var": "$warning",
          "invert": "$warning-invert"
        },
        {
          "name": "danger",
          "var": "$danger",
          "invert": "$danger-invert"
        },
        {
          "name": "blue",
          "var": "$blue",
          "invert": "$blue-invert"
        },
        {
          "name": "blue-background",
          "var": "$blue-background",
          "invert": "$grey"
        },
        {
          "name": "pink",
          "var": "$pink",
          "invert": "$pink-invert"
        },
        {
          "name": "orange",
          "var": "$orange",
          "invert": "$orange-invert"
        },
        {
          "name": "yellow",
          "var": "$yellow",
          "invert": "$yellow-invert"
        },
        {
          "name": "green",
          "var": "$green",
          "invert": "$green-invert"
        },
        {
          "name": "purple",
          "var": "$purple",
          "invert": "$purple-invert"
        },
        {
          "name": "turquoise",
          "var": "$turquoise",
          "invert": "$turquoise-invert"
        },
        {
          "name": "red",
          "var": "$red",
          "invert": "$red-invert"
        }
      ]
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/colors/index.js